import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, AlertTriangle, ExternalLink, X, ChevronDown } from 'lucide-react';
import { Trail } from '../lib/types';
import { TrailCard } from '../components/BikePark/TrailCard';
import { GondolaSection } from '../components/BikePark/GondolaSection';

const trails: Trail[] = [
  {
    name: "Monkey Business",
    length: "1969.10 m",
    difficulty: "black",
    altitudeDescent: "426 m",
    trailforksLink: "#"
  },
  {
    name: "Red Line",
    length: "1145.15 m",
    difficulty: "red",
    altitudeDescent: "187 m",
    trailforksLink: "#"
  },
  {
    name: "Drumul Rosu",
    length: "5222.07 m",
    difficulty: "green",
    altitudeDescent: "1 m",
    trailforksLink: "#"
  },
  {
    name: "CL Over",
    length: "963.62 m",
    difficulty: "red",
    altitudeDescent: "132 m",
    trailforksLink: "#"
  },
  {
    name: "Westreme",
    length: "2927.27 m",
    difficulty: "black",
    altitudeDescent: "542 m",
    trailforksLink: "#"
  },
  {
    name: "Killy's Backyard",
    length: "1887.40 m",
    difficulty: "blue",
    altitudeDescent: "163 m",
    trailforksLink: "#"
  },
  {
    name: "Respawn",
    length: "922.19 m",
    difficulty: "red",
    altitudeDescent: "453 m",
    trailforksLink: "#"
  }
];

export default function BikePark() {
  const [showBusSchedule, setShowBusSchedule] = useState(false);
  const [showAllTrails, setShowAllTrails] = useState(false);

  const displayedTrails = showAllTrails ? trails : trails.slice(0, 3);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-[60vh]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/nhvelo-f0124.appspot.com/o/NhVeloSite%2FWhatsApp%20Image%202025-01-12%20at%2013.12.37%20(4).jpeg?alt=media&token=6f241d54-6c0d-4c40-981f-59bacaf894d8"
          alt="Bike Park"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center text-white">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">NH Velo Bike Park</h1>
            <p className="text-xl md:text-2xl max-w-2xl mx-auto">
              Trasee pentru toate nivelurile de experiență
            </p>
          </div>
        </div>
      </section>

      {/* Trails Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-12">
            <div>
              <h2 className="text-4xl font-bold mb-4">Trasee</h2>
              <p className="text-xl text-gray-600">Explorează traseele noastre pentru toate nivelurile</p>
            </div>
            <Link
              to="/harta"
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2"
            >
              <MapPin className="w-5 h-5" />
              Vezi Harta
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedTrails.map((trail) => (
              <TrailCard key={trail.name} trail={trail} />
            ))}
          </div>

          {!showAllTrails && trails.length > 3 && (
            <div className="text-center mt-8">
              <button
                onClick={() => setShowAllTrails(true)}
                className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
              >
                Vezi toate traseele
                <ChevronDown className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Gondola Section */}
      <GondolaSection onShowBusSchedule={() => setShowBusSchedule(true)} />

      {/* Report Problem Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center justify-center gap-3 bg-red-100 text-red-800 px-4 py-2 rounded-full mb-8">
            <AlertTriangle className="w-5 h-5" />
            <span>Ai găsit o problemă pe traseu?</span>
          </div>
          <h2 className="text-4xl font-bold mb-8">Ajută-ne să menținem traseele sigure</h2>
          <Link
            to="/report"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors"
          >
            Raportează o problemă
            <ExternalLink className="w-5 h-5" />
          </Link>
        </div>
      </section>

      {/* Bus Schedule Modal */}
      {showBusSchedule && (
        <div className="fixed inset-0 bg-black/80 z-50 p-4 md:p-8">
          <div className="relative w-full h-full max-w-5xl mx-auto bg-white rounded-xl overflow-hidden">
            <button
              onClick={() => setShowBusSchedule(false)}
              className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100"
            >
              <X className="w-6 h-6" />
            </button>
            <iframe
              src="https://www.ratbv.ro/afisaje/20-dus.html"
              className="w-full h-full scale-80 origin-top"
            />
          </div>
        </div>
      )}
    </div>
  );
}